import React from 'react'
import { useForm } from 'react-final-form'
import { Box, Grid, makeStyles } from '@material-ui/core'
import { validateEmail } from '../../../../utilities/validate'
import useTranslate from '../../../../i18n/useTranslate'
import MyTextfield from '../../../../control/textfield/textfield'
import MyCheckbox from '../../../../control/checkbox/checkbox'
import MyButton from '../../../../control/button/button'

const MemberRowExternal: React.FC<{
    namePrefix: string
    onRemove?: () => void
    defaultNotify?: boolean
    requiredEmail?: boolean
    disableRemove?: boolean
    canEdit?: boolean
}> = ({ namePrefix, onRemove, defaultNotify = true, requiredEmail = false, disableRemove, canEdit = true }) => {
    const classes = useStyles()
    const form = useForm()
    const t = useTranslate()

    return (
        <Box className={classes.rowCard}>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                    <MyTextfield
                        name={`${namePrefix}.name`}
                        required
                        resetButtom
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.PARTICIPANTS.FULLNAME'),
                            placeholder: t.get('UM.SETTING_AGENDA.PARTICIPANTS.FULLNAME'),
                            disabled: !canEdit,
                        }}
                        handleValueChange={(val: string) => {
                            form.change(`${namePrefix}.fullnameEn`, val)
                            form.change(`${namePrefix}.fullnameTh`, val)
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MyTextfield
                        name={`${namePrefix}.email`}
                        required
                        resetButtom
                        validates={[validateEmail(t.get('MESSAGE.M017'))]}
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.PARTICIPANTS.EMAIL'),
                            placeholder: t.get('UM.SETTING_AGENDA.PARTICIPANTS.EMAIL'),
                            disabled: !canEdit,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.rightControls}>
                        <MyCheckbox
                            name={`${namePrefix}.sendMail`}
                            label={t.get('UM.SETTING_AGENDA.PARTICIPANTS.SEND_MAIL')}
                            disabled={!canEdit}
                        />
                        <MyButton
                            onClick={onRemove}
                            color="secondary"
                            disabled={disableRemove || !canEdit}
                            style={{ minWidth: 80 }}
                        >
                            {t.get('BUTTON.DELETE')}
                        </MyButton>
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    rowCard: {
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    rightControls: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        height: '100%',
    },
}))

export default React.memo(MemberRowExternal)
